<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card :loading="loading">
          <v-toolbar color="#f8f9fb" elevation="0">
            <v-toolbar-title>Feedback</v-toolbar-title>
            <v-spacer></v-spacer>
            <!-- <v-btn
              class="float-right"
              color="primary"
              to="/superadmin/society/add"
            >
              <v-icon left> mdi-plus </v-icon>
              Add Society
            </v-btn> -->
          </v-toolbar>
          <v-divider></v-divider>

          <v-card-text class="#f4f5f7">
            <v-data-table
              :headers="headers"
              :items="feedbacks"
              :search="search"
              class="elevation-3"
            >
              <template v-slot:top>
                <v-text-field
                  v-model="search"
                  label="Search"
                  clearable
                  append-icon="mdi-magnify"
                  single-line
                  hide-details
                  class="col-md-6"
                  @input="sessionStorage(search)"
                ></v-text-field>
              </template>
              <template v-slot:item.created_at="{ item }"
                >{{ dateFormatter(item.created_at) }}
              </template>
              <template v-slot:item.member="{ item }">
                <span v-if="item.member_id"> {{ item.member.name }}</span>
                <span v-else>{{ item.society.name }}</span>
              </template>
              <template v-slot:item.status="{ item }">
                <span v-if="item.status === 1">Pending</span>
                <span v-if="item.status === 2">Declined</span>
                <span v-if="item.status === 3">Completed</span>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-icon size="large" @click="openView(item.id)">
                  mdi-eye
                </v-icon>
                <v-icon size="large" @click="deleteItem(item.id)">
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
          </v-card-text>
          <v-dialog v-model="dialogDelete" max-width="450" persistent>
            <v-card>
              <v-card-title class="text-h5 grey lighten-2">
                Confirm!!
              </v-card-title>
              <v-card-text class="mt-2"
                >Are you sure you want to delete this feedback ?</v-card-text
              >
              <v-divider></v-divider>

              <v-card-actions class="justify-end">
                <v-btn
                  color="primary"
                  text
                  @click="deleteFeedback"
                  class="delete-btn"
                >
                  yes</v-btn
                >
                <v-btn color="primary" text @click="closeDelete">no</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogView" max-width="450" persistent>
            <v-card>
              <v-card-title class="text-h5 grey lighten-2">
                View Feedback
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-text-field
                    readonly
                    v-model="feedback.title"
                    label="Title"
                    outlined
                  >
                  </v-text-field>
                  <v-text-field
                    v-model="feedback.description"
                    label="Description"
                    outlined
                    readonly
                  ></v-text-field>
                  <v-text-field
                    :value="dateFormatter(feedback.created_at)"
                    label="Date"
                    outlined
                    readonly
                  ></v-text-field>
                  <v-text-field
                    :value="
                      feedback.member
                        ? feedback.member.name
                        : feedback.society.name
                    "
                    label="Reported by"
                    outlined
                    readonly
                  ></v-text-field>
                  <v-select
                    v-model="feedback.status"
                    :items="items"
                    :item-text="'label'"
                    :item-value="'value'"
                    label="Status"
                    outlined
                  ></v-select>
                  <div @click="imagePopupOpen" v-if="feedback.picture_url">
                    <v-img
                      :src="API_BASE_URL + '/uploads/' + feedback.picture_url"
                      aspect-ratio="1"
                      width="40%"
                      height="100%"
                      class="grey lighten-2"
                    ></v-img>
                  </div>
                </v-container>
              </v-card-text>
              <v-divider></v-divider>

              <v-card-actions class="justify-end">
                <v-btn
                  color="primary"
                  text
                  @click="updateStatus(feedback.id)"
                  class="delete-btn"
                >
                  Update</v-btn
                >
                <v-btn color="primary" text @click="closeView">cancel</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="imageDialog" style="max-width: 80vw" persistent>
            <v-card class="image-card">
              <v-btn
                class="close-btn"
                color="primary"
                @click="imagePopupClose"
                icon
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>

              <v-card-text class="text-container">
                <div class="centered-text">
                  <v-img
                    :src="API_BASE_URL + '/uploads/' + feedback.picture_url"
                    width="700"
                    height="550"
                  ></v-img>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      items: [
        { label: "Pending", value: 1 },
        { label: "Declined", value: 2 },
        { label: "Completed", value: 3 },
      ],
      feedback: { member: {} },
      loading: false,
      dialogDelete: false,
      dialogView: false,
      deletingItemId: "",
      search: "",
      headers: [
        {
          text: "Title",
          align: "start",
          value: "title",
          width: "15%",
        },
        {
          text: "Description",
          align: "start",
          value: "description",
        },
        {
          text: "Reported by",
          align: "start",
          value: "member",
        },
        {
          text: "Date",
          align: "center",
          value: "created_at",
        },
        {
          text: "Status",
          align: "start",
          value: "status",
        },
        {
          text: `${this.$t("society.list.headers.actions")}`,
          value: "actions",
          width: "8%",
          sortable: false,
        },
      ],
      feedbacks: [],
      imageDialog: false,
    };
  },

  methods: {
    ...mapMutations("alert", ["setAlert"]),
    imagePopupOpen() {
      this.imageDialog = true;
    },
    imagePopupClose() {
      this.imageDialog = false;
    },
    getFeedback() {
      let _self = this;

      _self.$axios.get("superadmin/feedback").then((response) => {
        let data = response.data;

        if (data.status) {
          _self.feedbacks = data.feedback;
        } else {
          _self.setAlert({
            showAlert: true,
            variant: "red accent-3",
            timeout: "2000",
            message: data.message,
          });
        }
      });
    },
    dateFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    deleteItem(itemId) {
      this.dialogDelete = true;
      this.deletingItemId = itemId;
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    openView(itemId) {
      this.getFeedbackByID(itemId);
      this.dialogView = true;
    },
    closeView() {
      this.dialogView = false;
    },

    async deleteFeedback() {
      let _self = this;
      this.dialogDelete = false;

      _self.$axios
        .delete("superadmin/feedback/" + this.deletingItemId)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            this.getFeedback();
            this.setAlert({
              showAlert: true,
              variant: "green accent-4",
              timeout: "2000",
              message: data.message,
            });
          } else {
            this.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    getFeedbackByID(id) {
      let _self = this;

      _self.$axios.get("superadmin/feedback/" + id).then((response) => {
        let data = response.data;

        if (data.status) {
          _self.feedback = data.feedback;
        } else {
          _self.setAlert({
            showAlert: true,
            variant: "red accent-3",
            timeout: "2000",
            message: data.message,
          });
        }
      });
    },

    updateStatus(id) {
      let _self = this;
      const data = { status: _self.feedback.status };

      _self.$axios.put("superadmin/feedback/" + id, data).then((response) => {
        let data = response.data;

        if (data.status) {
          this.getFeedback();
          this.dialogView = false;
          this.setAlert({
            showAlert: true,
            variant: "green accent-4",
            timeout: "2000",
            message: data.message,
          });
        } else {
          this.setAlert({
            showAlert: true,
            variant: "red accent-3",
            timeout: "2000",
            message: data.message,
          });
        }
      });
    },

    sessionStorage(search) {
      if (search === null || search === "" || search === undefined) {
        sessionStorage.removeItem("society_search");
      } else {
        sessionStorage.setItem("society_search", search);
      }
    },
  },
  mounted() {
    this.getFeedback();
    this.search = sessionStorage.getItem("society_search");
  },
};
</script>

<style scoped>
/* Custom styling for the close button */
.close-btn {
  position: absolute;
  top: 5px;
  right: 2px;
}
.text-container {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.centered-text {
  text-align: center;
}

.v-dialog > .v-card > .v-card__text {
    padding: 0;
}
</style>
